module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAn0lEQVRYhe3WsQ2DQAyF4V++RRiFDRiBEWADVoqET7SMkA0yQrJB0qQJ4QoU6ySi90mvsyUXLh7IjxZoMjZkbPoMXWknQ/c9H55hgQbH7pn03Itj4/Y4x8bSfHzshmPX0sAM7fbAGdp6B6Y19l9ERETksHfd2qk7qluqWyIiIhKgVLec1Jd2nNRXqFvTOepWJq3H65Y9Kh15CX4Ykf/zAvpx4HU2d13IAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/action.png
// module id = mPIS
// module chunks = 5